import { styled } from "styled-components";

export const FooterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #fff;
  color: #383838;
  border-radius: 30px;
  cursor: pointer;
  font-size: 24px;
  width: 70px;
  height: 70px;
  gap: 8px;
`;
